var exports = {
  "n": "x43aef4ae--69ad9d--controls",
  "q": "x43aef4ae--69ad9d--controls-multiple",
};

module.exports = exports;
